<template>
  <div>
    <strong class="mb-2 mr-2 d-inline-block">{{ $i18nPresenter.t('Insert after slide:') }}</strong>
    <aha-select
      class="py-3"
      v-model="selectedSlideOrder"
      :disabled="areSlidesLoading || !selectedPresentationId"
      @change="onChangeSelectedSlideOrder"
    >
      <aha-select-option value="-1" hidden>
        {{ $i18nPresenter.t('Loading slides...') }}
      </aha-select-option>

      <aha-select-option value="0">
        {{ $i18nPresenter.t('(Make it first)') }}
      </aha-select-option>

      <aha-select-option
        :key="slide.id"
        :value="slide.order"
        v-for="(slide, index) in slides"
      >
        <span>{{ index + 1 }}</span>
        <span> - </span>
        <span>
          {{ renderSlideTitle(slide) }}
        </span>
      </aha-select-option>
    </aha-select>

    <div
      v-if="selectedSlides.some(item => item.type === 'leaderboard')"
      class="mb-2 text-xs text-base-70"
    >
      {{ $i18nPresenter.t(
        'Rankings on the Leaderboard are calculated live based on the previous Quiz slides. To copy the rankings data, you just need to copy all the previous Quiz slides over.'
      ) }}
    </div>

    <div
      v-if="selectedSlides.some(item => item.type === 'question')"
      class="mb-2 text-xs text-base-70"
    >
      {{ $i18nPresenter.t(
        'If checked, all Q&A data from this presentation will be merged into the destination presentation.'
      ) }}
    </div>

    <aha-checkbox v-model="isIncludingResponseData" @change="onChangeIncludingResponseData">
      {{ $i18nPresenter.t('Includes response data') }}
    </aha-checkbox>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Constants from '@/constant'

export default {
  props: {
    selectedPresentationId: {
      type: Number,
      default: null,
    },
    areSlidesLoading: {
      type: Boolean,
      default: false,
    },
    slides: {
      type: Array,
      default: () => [],
    },
    selectedSlides: {
      type: Array,
      default: () => [],
    },
  },
  data: () => {
    return {
      selectedSlideOrder: 0,
      isIncludingResponseData: true,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
  mounted() {
    const userSettings = this.currentUser.rememberSettings
    if (userSettings && userSettings.isIncludingResponseData !== undefined) {
      this.isIncludingResponseData = userSettings.isIncludingResponseData
    } else {
      this.isIncludingResponseData = true
    }
  },
  methods: {
    onChangeSelectedSlideOrder() {
      this.$emit('onChangeSelectedSlideOrder', this.selectedSlideOrder)
    },
    onChangeIncludingResponseData() {
      this.$emit('onChangeIncludingResponseData', this.isIncludingResponseData)
    },
    renderSlideTitle(slide) {
      const { title, type, slideType } = slide

      if (title && title.trim()) {
        const trimmedTitle = title.trim()

        if (trimmedTitle.length > 40) {
          return `${trimmedTitle.slice(0, 40)}...`
        }

        return trimmedTitle
      }

      return this.convertTypeToName(type, slideType)
    },
    convertTypeToName(type, slideType) {
      if (type === 'pickAnswer') {
        if (slideType === 'imageChoice') return 'Pick Image'
        if (slideType === 'typeAnswer') return 'Type Answer'
      }

      let types = []
      Constants.allTypeSections.forEach((item) => {
        types = types.concat(item.slideTypes)
      })

      const matchType = types.find((item) => item.type === type)
      if (matchType && matchType.name) {
        return matchType.name
      }
      return ''
    },
  },
}
</script>
